module.exports = __webpack_public_path__ + "img/magazine16.67d733f9.jpg";